import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Formik } from "formik";
import Form from "app/components/Form";
import { DisbursementRequestComponent, useDisbursementsMultipleAttachmentFeatureFlagQuery, } from "generated/generated-models";
import { Guid } from "guid-typescript";
import { nameof } from "core/util/nameof";
import Datepicker from "app/components/DatePicker";
import { yupDisbursementRequestInput } from "./yupDisbursementRequestInput";
import { CApolloError } from "../common/CApolloError";
import { DisbursementRequestSuccessful } from "./DisbursementRequestSuccessful";
import { toDateOnly } from "core/util/dateExtensions";
import Input from "app/components/Input";
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, useMediaQuery, } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { FileThumb } from "./FileThumb";
import { useState } from "react";
import { clientConfigFn } from "clientConfig";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { CError } from "app/common/CError";
import { FileUploader } from "app/authentication/SecureMessaging/FileUploader";
import AddAttachment from "app/authentication/SecureMessaging/AddAttachment";
const DisbursementRequestForm = (props) => {
    const [files, setFiles] = useState([]);
    const [fileDatas, setFileDatas] = useState([]);
    const [fileError, setFileError] = useState("");
    const [fileData, setFileData] = useState("");
    const [fileName, setFileName] = useState("");
    const [file, setFile] = useState();
    const fullScreen = useMediaQuery("(max-width: 768px)");
    const [, setOpen] = useState(false);
    const { data: featureFlag } = useDisbursementsMultipleAttachmentFeatureFlagQuery();
    const enableDisbursementsMultipleAttachments = featureFlag?.featureFlag?.EnableDisbursementMultipleAttachments;
    const handleClose = () => {
        setOpen(false);
    };
    const getBase64 = async (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                let encoded = reader.result
                    ?.toString()
                    .replace(/^data:(.*,)?/, "");
                if (encoded && encoded.length % 4 > 0) {
                    encoded += "=".repeat(4 - (encoded.length % 4));
                }
                resolve(encoded);
            };
        });
    };
    const handleUpload = async (e) => {
        if (e.target && e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setFile(file);
            setFileName(file.name);
            const base64 = await getBase64(file);
            setFileData(base64);
        }
    };
    const handleMultipleFileUpload = async (file, data) => {
        const error = await FileUploader.validateFile(file);
        if (error) {
            setFileError(error);
            return;
        }
        setFiles((prevFiles) => [...prevFiles, { file, id: Guid.raw() }]);
        setFileDatas((prevFileData) => [
            ...prevFileData,
            {
                fileName: file.name,
                fileSize: file.size,
                data: data,
            },
        ]);
        setFileError(null);
    };
    const handleRemoveMultipleFile = (file) => {
        setFiles((prevFiles) => prevFiles.filter((fileItem) => fileItem.file !== file));
        setFileDatas((prevFileData) => {
            const updatedFileData = Array.isArray(prevFileData)
                ? prevFileData.filter((fileItem) => fileItem.fileName !== file.name)
                : [];
            return updatedFileData;
        });
    };
    const handleRemoveFile = () => {
        setFile(undefined);
    };
    return (_jsx("section", { className: "sub-wrap disbursement-request", children: !props.DisableDisbursements ? (_jsx(DisbursementRequestComponent, { children: (mutateFn, { called, data, error, loading }) => (_jsx(Formik, { initialValues: {
                    File: "",
                    FileName: "",
                    FileData: [],
                    InstrumentId: `${props.InstrumentId}`,
                    AccountId: props.AccountId.toString(),
                    AccountNumber: "",
                    BankIdentifierText: "",
                    PayeeName: "",
                    PaymentDate: toDateOnly(new Date()),
                    PaymentDescription: "",
                    RequestedAmount: 0,
                    SupplierBankAccountName: "",
                    Note: "",
                }, onSubmit: (values) => {
                    if (values) {
                        mutateFn({
                            variables: {
                                input: {
                                    ...values,
                                    File: fileData,
                                    FileName: fileName,
                                    FileData: fileDatas,
                                },
                            },
                            update: (_cache, result) => {
                                console.debug("Disbursement Request", result);
                            },
                        });
                    }
                }, validationSchema: yupDisbursementRequestInput, children: () => {
                    if (called && !loading && error) {
                        return _jsx(CApolloError, { error: error });
                    }
                    if (called && !loading && !error) {
                        return (_jsxs(Dialog, { fullScreen: fullScreen, open: true, className: "success-requested-disbursement", onClose: handleClose, children: [_jsx(DialogTitle, { children: _jsx(ReceiptLongIcon, {}) }), _jsx(DialogContent, { sx: { m: 4, mt: 0 }, children: _jsxs(DialogContent, { children: [data &&
                                                data.disbursementRequest &&
                                                data.disbursementRequest
                                                    .Data && (_jsx(DisbursementRequestSuccessful, { disbursement: data
                                                    .disbursementRequest
                                                    .Data })), _jsx("div", { className: "button-row", children: _jsx(Button, { fullWidth: true, type: "submit", id: "submit", sx: {
                                                        p: 1.5,
                                                        mt: 1,
                                                    }, onClick: () => window.location.reload(), variant: "contained", children: "Done" }) })] }) })] }));
                    }
                    return (_jsxs(Box, { className: "disbursement-details", children: [_jsx("h3", { children: "Request New Disbursement" }), _jsx(Form, { children: _jsxs(Grid, { container: true, spacing: 2, sx: { mt: 2 }, children: [_jsx(Grid, { item: true, xs: 6, children: _jsx(Input, { name: nameof("PayeeName"), type: "text", label: "Supplier Name" }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(Input, { name: nameof("BankIdentifierText"), type: "bsb", label: "Supplier BSB" }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(Input, { name: nameof("AccountNumber"), type: "text", label: "Supplier Account Number" }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(Input, { name: nameof("PaymentDescription"), type: "text", label: "Payment Description" }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(Input, { name: nameof("RequestedAmount"), type: "currency", label: "Amount" }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(Datepicker, { name: nameof("PaymentDate"), label: "Payment Date", minDate: new Date() }) }), _jsx(Grid, { item: true, xs: 6, children: _jsxs("div", { className: "form-group", children: [!enableDisbursementsMultipleAttachments && (_jsx("label", { htmlFor: "File", children: "Supporting Documentation" })), clientConfigFn()
                                                        .disbursementFileText && (_jsx("p", { className: "help-block", children: clientConfigFn()
                                                            .disbursementFileText })), _jsx("div", { className: "upload-container", children: enableDisbursementsMultipleAttachments ? (_jsx(AddAttachment, { onFileUpload: handleMultipleFileUpload, label: "Supporting Documentation" })) : (_jsxs("div", { className: "upload-wrap", children: [_jsx("input", { id: "File", name: "File", type: "file", onChange: (event) => {
                                                                        handleUpload(event);
                                                                    }, className: "form-control file-upload-input" }), _jsxs("div", { className: "drag-text", children: [_jsx("h3", { children: "Drag & drop" }), _jsx("p", { children: "or browse your files" })] })] })) }), _jsx("p", { className: "helper-text", children: "For example, an invoice, estimate of fees or a receipt." })] }) }), _jsx(Grid, { item: true, xs: 6, children: _jsxs("section", { className: "file-upload-group", children: [fileError && (_jsx(CError, { error: fileError })), enableDisbursementsMultipleAttachments ? (files.map((file) => (_jsx(FileThumb, { file: file.file, onRemove: handleRemoveMultipleFile }, file.id)))) : (_jsx(FileThumb, { file: file, onRemove: handleRemoveFile }))] }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(Input, { name: nameof("Note"), type: "text", label: "Note" }) }), _jsx(Grid, { item: true, xs: 12, children: _jsxs("div", { className: "form-group button-row", children: [_jsx(Button, { sx: {
                                                            width: 150,
                                                            p: 1.5,
                                                            mt: 1,
                                                        }, variant: "contained", className: "btn-cancel", onClick: () => window.location.reload(), id: "cancel", children: "Cancel" }), _jsx(LoadingButton, { type: "submit", id: "submit", sx: {
                                                            p: 1.5,
                                                            mt: 1,
                                                        }, loadingPosition: "end", variant: "contained", disabled: (called &&
                                                            loading) ||
                                                            (data &&
                                                                data.disbursementRequest &&
                                                                data
                                                                    .disbursementRequest
                                                                    .Success) ||
                                                            undefined, children: "Request Disbursement" })] }) })] }) })] }));
                } })) })) : (_jsx("section", { className: "sub-wrap", children: _jsx(CError, { error: "Account is not available for disbursements" }) })) }));
};
export default DisbursementRequestForm;
